import { Navigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { jwtDecode } from 'jwt-decode';

export default function AdminRoute({ children }) {
    const [cookies] = useCookies(["token"]);
    const token = cookies.token;

    if (!token) return <Navigate to="/" replace />;
    try {
        const decoded = jwtDecode(token);
        if (decoded.exp * 1000 < Date.now()) return <Navigate to="/" replace />;
        if (!decoded.role || String(decoded.role).toLowerCase() !== 'admin') return <Navigate to="/" replace />;
    } catch (e) {
        return <Navigate to="/" replace />;
    }
    return children;
}
